export function makeAttachedBlock(tag: string, preamble: string) {
  const block = new RegExp(`<${tag}>\\n[\\s\\S]*?\\n</${tag}>`, "g");

  const build = (items: readonly { name: string }[]): string => {
    const names = items.map((item) => `- ${item.name}`).join("\n");
    return `<${tag}>\n${preamble}\n${names}\n</${tag}>`;
  };

  const prepend = (text: string, items: readonly { name: string }[]): string =>
    items.length === 0 ? text : build(items) + (text ? `\n\n${text}` : "");

  const names = (text: string): string[] => [
    ...new Set(
      [...text.matchAll(block)].flatMap((match) =>
        match[0]
          .split("\n")
          .filter((line) => line.startsWith("- "))
          .map((line) => line.slice(2).trim())
          .filter(Boolean)
      )
    ),
  ];

  const strip = (text: string): string => text.replace(block, "").trim();

  return { build, prepend, names, strip };
}
